/* selector-comuna.js - Selector de Comuna Independiente */

(function () {
  'use strict';

  /* helpers */
  const $ = id => document.getElementById(id);
  const numberFormat = amount => { 
    amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); 
    if(isNaN(amount) || amount === 0) return '0'; 
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); 
  };
  
  // Sanitizar contenido para prevenir XSS
  const sanitize = str => {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  };

  // Logger seguro que no expone datos sensibles
  const secureLog = (message, details = null) => {
    if (process?.env?.NODE_ENV === 'development') {
      console.log(`[Comuna Selector] ${message}`, details);
    }
  };

  /* DATOS DE REGIONES Y COMUNAS DE CHILE */
  const getChileData = () => window.CHILE_REGIONS_DATA || [];

  /* Variables globales */
  let selectedRegion = null;
  let selectedCommune = null;

  /* Nodos DOM */
  let regionSelect, communeSelect, ratesPreview;

  /* Configuración */
  const config = {
    forceCommuneSelection: true,
    showRates: true,
    country: 'CL'
  };

  const btns = () => document.querySelectorAll('[name="checkout"]');
  const toggleBtns = e => btns().forEach(b => b.disabled = !e);

  /* VALIDACIONES */
  
  const validateCommune = () => {
    const communeOk = !config.forceCommuneSelection || (selectedCommune && selectedCommune !== '');
    toggleBtns(communeOk);
    return communeOk;
  };

  /* FUNCIONES DE COMUNA */

  const loadRegions = () => {
    try {
      const regions = getChileData();
      let html = '<option value="">Selecciona una región</option>';
      regions.forEach(region => {
        html += `<option value="${region.regionCode}">${region.regionName}</option>`;
      });
      
      regionSelect.innerHTML = html;
      regionSelect.classList.remove('hidden');
      
    } catch (error) {
      console.error('Error cargando regiones:', error);
      regionSelect.innerHTML = '<option value="">Error cargando regiones</option>';
    }
  };

  const loadCommunes = () => {
    const regionCode = regionSelect.value;
    
    if (!regionCode) {
      communeSelect.innerHTML = '<option value="">Selecciona una región primero</option>';
      communeSelect.classList.add('hidden');
      ratesPreview.innerHTML = '';
      selectedRegion = null;
      selectedCommune = null;
      validateCommune();
      return;
    }

    selectedRegion = getChileData().find(r => r.regionCode === regionCode);
    
    if (selectedRegion) {
      let html = '<option value="">Selecciona una comuna</option>';
      selectedRegion.communes.forEach(commune => {
        html += `<option value="${commune}">${commune}</option>`;
      });
      
      communeSelect.innerHTML = html;
      communeSelect.classList.remove('hidden');
    }

    ratesPreview.innerHTML = '';
    selectedCommune = null;
    validateCommune();
  };

  const loadShippingRates = async () => {
    if (!config.showRates || !selectedRegion || !selectedCommune) {
      ratesPreview.innerHTML = ''; // Limpiar si no hay comuna seleccionada
      return;
    }

    ratesPreview.innerHTML = '<p class="rates-title">Calculando tarifas...</p>';

    try {
      // Usar código postal simple basado en región (formato chileno simplificado)
      const getPostalCode = (regionCode) => {
        // Usar códigos más simples y genéricos
        const postalCodes = {
          'AP': '1000001', // Arica
          'TA': '1100001', // Iquique
          'AN': '1200001', // Antofagasta
          'AT': '1500001', // Copiapó
          'CO': '1700001', // La Serena
          'VS': '2300001', // Valparaíso
          'RM': '7500001', // Santiago
          'LI': '2800001', // Rancagua
          'ML': '3400001', // Talca
          'NB': '3700001', // Chillán
          'BI': '4000001', // Concepción
          'AR': '4700001', // Temuco
          'LR': '5000001', // Valdivia
          'LL': '5400001', // Puerto Montt
          'AI': '5900001', // Coihaique
          'MG': '6100001'  // Punta Arenas
        };
        return postalCodes[regionCode] || '0000001';
      };

      const postalCode = getPostalCode(selectedRegion.regionCode);
      const url = `/cart/shipping_rates.json?shipping_address[country]=${encodeURIComponent(config.country)}&shipping_address[province]=${encodeURIComponent(selectedRegion.regionName)}&shipping_address[city]=${encodeURIComponent(selectedCommune)}&shipping_address[zip]=${postalCode}`;
      
      const response = await fetch(url);
      const data = await response.json();

      if (data.error) {
        ratesPreview.innerHTML = `<p style="color: #d63638;">Error al calcular tarifas</p>`;
        secureLog('Shipping rates error', { hasError: true });
        return;
      }

      const rates = data.shipping_rates || [];
      
      if (rates.length === 0) {
        ratesPreview.innerHTML = '<p>No hay tarifas disponibles para esta comuna</p>';
        return;
      }

      // Crear elementos DOM de forma segura en lugar de innerHTML
      const container = document.createElement('div');
      container.className = 'rates-title';
      container.textContent = 'Tarifas de envío disponibles:';
      ratesPreview.innerHTML = '';
      ratesPreview.appendChild(container);
      
      rates.forEach(rate => {
        const rateDiv = document.createElement('div');
        rateDiv.className = 'rate-item';
        
        const nameSpan = document.createElement('span');
        nameSpan.className = 'rate-name';
        nameSpan.textContent = sanitize(rate.name || 'Sin nombre');
        
        const priceSpan = document.createElement('span');
        priceSpan.className = 'rate-price';
        priceSpan.textContent = '$' + numberFormat(rate.price || '0');
        
        rateDiv.appendChild(nameSpan);
        rateDiv.appendChild(priceSpan);
        ratesPreview.appendChild(rateDiv);
      });
    } catch (error) {
      secureLog('Error loading shipping rates', { type: 'fetch_error' });
      ratesPreview.innerHTML = '<p style="color: #d63638;">Error cargando tarifas</p>';
    }
  };

  /* PERSISTENCIA Y ENVÍO */

  const push = () => fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({attributes: {
      // Solo datos de envío
      shipping_region: selectedRegion ? selectedRegion.regionName : '',
      shipping_region_code: selectedRegion ? selectedRegion.regionCode : '',
      shipping_commune: selectedCommune || ''
    }})
  }).catch(() => {});

  /* EVENT LISTENERS */

  const bind = () => {
    if (regionSelect && regionSelect.dataset.bound) return;
    if (regionSelect) regionSelect.dataset.bound = '1';

    // Eventos de región y comuna
    if (regionSelect) {
      regionSelect.addEventListener('change', () => {
        loadCommunes();
        push();
      });
    }

    if (communeSelect) {
      communeSelect.addEventListener('change', () => {
        selectedCommune = communeSelect.value;
        // Limpiar rates si se deselecciona comuna
        if (!selectedCommune) {
          ratesPreview.innerHTML = '';
        } else if (config.showRates) {
          loadShippingRates();
        }
        validateCommune();
        push();
      });
    }

    // Eventos de checkout
    document.addEventListener('click', e => {
      const btn = e.target.closest('[name="checkout"]');
      if (!btn) return;
      
      if (!validateCommune()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      } else {
        e.preventDefault();
        push().then(() => {
          fetch('/cart.js').then(() => {
            // Modificar la URL del formulario si se seleccionó comuna
            if (selectedRegion && selectedCommune) {
              const form = document.getElementById('cart') || document.querySelector('form[action*="/cart"]');
              if (form) {
                form.action = `/cart?checkout[shipping_address][country]=${encodeURIComponent(config.country)}&checkout[shipping_address][province]=${encodeURIComponent(selectedRegion.regionName)}&checkout[shipping_address][city]=${encodeURIComponent(selectedCommune)}`;
              }
            }
            window.location.href = '/checkout';
          });
        });
      }
    }, true);

    document.addEventListener('submit', e => {
      if (!e.target.matches('form[action^="/cart"]')) return;
      
      if (!validateCommune()) {
        e.preventDefault();
        return false;
      } else {
        push();
      }
    }, true);
  };

  /* INICIALIZACIÓN */

  const init = () => {
    // Nodos de envío
    regionSelect = $('shipping_region_select');
    communeSelect = $('shipping_comuna_select');
    ratesPreview = $('shipping_rates_preview');

    // Solo inicializar si existen los elementos
    if (!regionSelect) return;

    // Cargar regiones y configurar eventos
    loadRegions();
    bind();
  };

  /* AUTO-INICIALIZACIÓN */

  document.addEventListener('DOMContentLoaded', init);
  ['shopify:section:load', 'cart:updated', 'ajaxCart:opened', 'cart-updated', 'add-to-cart']
    .forEach(ev => document.addEventListener(ev, init));
  window.addEventListener('pageshow', e => { if (e.persisted) init(); });

  /* Observer para drawer AJAX */
  new MutationObserver(() => {
    const el = document.getElementById('shipping_region_select');
    if (el && !el.dataset.bound) init();
  }).observe(document.body, { childList: true, subtree: true });

  // Exponer funciones globalmente para que otros módulos puedan validar
  window.CommuneSelector = {
    isValid: validateCommune,
    getSelected: () => ({ region: selectedRegion, commune: selectedCommune })
  };

})(); 